export default __webpack_public_path__ + "static/media/1322.05a4c701.png";